import moment from 'moment';
import jQuery from 'jquery';
import _ from 'underscore';

import template from './template.html';

function DateAndEventPicker(eventService, dateUtilsService, alertService, sdkUtils, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    require: '?ngModel',
    template,
    scope: {
      venueId: '@'
    },
    link: (scope, element, attrs, ngModelCtrl) => {
      scope.showDropdown = false;
      scope.currentView = 'CALENDAR';
      scope.selectEvent = function (event, $event) {
        if ($event) $event.preventDefault();

        ngModelCtrl.$setViewValue(event.date);

        scope.showDropdown = false;
      };
      scope.focusEventSearch = false;

      scope.$watch('currentView', val => {
        if (val === 'EVENTS') {
          $timeout(() => {
            scope.focusEventSearch = true;
          });
        } else {
          scope.focusEventSearch = false;
        }
      });

      scope.eventSearch = function (event) {
        if (!scope.eventSearchTerm) return true;

        const searchTerm = scope.eventSearchTerm.toLowerCase();

        const eventFullDateString = `${event.dateDay.toLowerCase()} ${event.dateMonth.toLowerCase()} ${event.dateDate.toLowerCase()}`;
        const eventMonthDateString = `${event.dateMonth.toLowerCase()} ${event.dateDate.toLowerCase()}`;

        if (event.name.toLowerCase().startsWith(searchTerm)) return true;
        if (eventFullDateString.startsWith(searchTerm)) return true;
        if (eventMonthDateString.startsWith(searchTerm)) return true;
        if (event.dateDay.toLowerCase().startsWith(searchTerm)) return true;
        if (event.dateDate.toLowerCase().startsWith(searchTerm)) return true;
        if (event.dateYear.toLowerCase().startsWith(searchTerm)) return true;
        if (event.dateMonth.toLowerCase().startsWith(searchTerm)) return true;
        if (event.dateYear.toLowerCase().startsWith(searchTerm)) return true;

        return false;
      };

      ngModelCtrl.$formatters.push(modelValue => {
        if (!moment.isMoment(modelValue)) throw new Error('input must be a moment object');

        scope.displayDate = modelValue;

        scope.datePickerDate = scope.displayDate.toDate();

        //https://github.com/angular-ui/bootstrap/issues/2952#issuecomment-102751097
        //NOTE: required because the date picker only support js Dates - so it always displays in local time
        //forces the "local" version of the date to match the intended UTC date
        scope.datePickerDate = new Date(scope.datePickerDate.getTime() + (60000 * scope.datePickerDate.getTimezoneOffset()));

        if (!scope.eventsLoaded) _getEvents();

        return scope.datePickerDate;
      });

      scope.$watch('datePickerDate', val => {
        //https://github.com/angular-ui/bootstrap/issues/2952#issuecomment-102751097
        //NOTE: required because the date picker only support js Dates - so it always displays in local time
        //forces the "local" version of the date to match the intended UTC date
        const date = new Date(val.getTime() - (60000 * val.getTimezoneOffset()));

        scope.displayDate = moment.utc(date);

        ngModelCtrl.$setViewValue(scope.displayDate);
      });

      scope.datePickerOptions = {
        mode: 'simple',
        maxMode: 'day',
        showWeeks: false
      };

      scope.showHideDatePicker = function () {
        scope.showDropdown = !scope.showDropdown;
      };

      jQuery(document).on('click', _bodyClickHandler);

      scope.$on('$destroy', () => {
        jQuery(document).off('click', _bodyClickHandler);
      });

      function _bodyClickHandler(event) {
        const isClickedElementChildOfPopup = element
          .find(event.target)
          .length > 0;

        if (isClickedElementChildOfPopup) {
          return;
        }

        scope.$apply(() => {
          scope.showDropdown = false;
        });
      }

      function _getEvents() {
        const start = moment.utc();
        const end = start.clone().add(3, 'month').endOf('month');

        return eventService.listByVenueId(scope.venueId, {
            fields: 'venue(id), date, name, primaryImage, images',
            start: dateUtilsService.toUTCTimestampWithoutTime(start),
            end: dateUtilsService.toUTCTimestampWithoutTime(end)
          })
          .then(events => {
            scope.eventsLoaded = true;

            scope.events = _.map(events, event => {
              event.date = moment.utc(event.date);
              event.dateFormatted = event.date.format('ddd, MMM. Do YYYY');
              event.dateDay = event.date.format('dddd');
              event.dateDate = event.date.format('Do');
              event.dateYear = event.date.format('YYYY');
              event.dateMonth = event.date.format('MMMM');
              event.dateYear = event.date.format('YYYY');
              if (event.primaryImage) event.backgroundImage = `url(${event.primaryImage.small})`;
              return event;
            });
          })
          .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
      }
    }
  };
}

DateAndEventPicker.$inject = [
  'jsSdk.event',
  'dateUtilsService',
  'alertService',
  'jsSdk.utils',
  '$timeout'
];

export default DateAndEventPicker;



// WEBPACK FOOTER //
// ./src/directives/dateAndEventPicker/index.js